module.exports = __webpack_public_path__ + "img/UTFRON.56c9e35f.png";